<template>
  <v-navigation-drawer app clipped right
    v-model="config.status.active"
    class="grey lighten-4"
    :width="isExpanded ? 600 : 300">
    <v-tabs grow
      v-model="store.tab"
      background-color="white"
      @change="change({ type: 'book' })">
      <v-tab v-for="(item, idx) in getTabItems" :key="idx">
        <span :class="idx === store.tab ? 'font-weight-bold' : ''">{{ item }}</span>
      </v-tab>
    </v-tabs>
    <v-toolbar flat color="grey lighten-4">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn small fab text color="secondary" v-on="on" @click="toggleExpansion">
            <v-icon>{{ isExpanded ? 'fal fa-compress-alt' : 'fal fa-expand-alt' }}</v-icon>
          </v-btn>
        </template>
        <span>{{ isExpanded ? '縮小する' : '拡大する' }}</span>
      </v-tooltip>
      <v-select solo flat hide-details
        v-if="getTabSlug === 'bank'"
        background-color="transparent"
        v-model="store.bank"
        :items="getBankItems"
        @change="change({ type: 'company' })"
      />
      <v-select solo flat hide-details
        v-else-if="getTabSlug === 'card'"
        background-color="transparent"
        v-model="store.card"
        :items="getCardItems"
        @change="change({ type: 'company' })"
      />
      <v-menu bottom right offset-y
        :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn fab text small
            v-on="on"
            class="mr-2"
            color="secondary"><v-icon small>fa-bars</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-select multiple
                  v-model="form.areas"
                  label="支店"
                  :items="getAreaItems"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-divider></v-divider>
    <v-progress-linear indeterminate :color="isLoading ? 'secondary' : 'transparent'" />
    <v-window v-model="store.window">
      <v-window-item value="folders">
        <template v-for="item in getBookFolders">
          <v-list-item :key="item.id" :disabled="isLoading" @click="openFolder(item)">
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="my-0">
              <v-icon small>fal fa-angle-right</v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider :key="`${item.id}_div`"></v-divider>
        </template>
      </v-window-item>
      <v-window-item value="files">
        <template v-for="item in getBookFiles">
          <v-list-item
            class="px-0"
            :key="item.id"
            :disabled="isLoading"
            @click="collect(item)">
              <v-list-item-avatar class="mr-0">
                <v-icon small :color="form.gid === item.id ? 'secondary' : ''">{{ form.gid === item.id ? 'fa-check-square' : 'fal fa-file-excel' }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="caption">{{ item.name }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="my-0" @click.stop="">
                <v-menu bottom right offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn fab text small
                      v-on="on"
                      class="mr-2"
                      color="secondary"
                      :disabled="isLoading"><v-icon small>fa-ellipsis-v</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="openPreviewer(item)">
                      <v-list-item-avatar>
                        <v-icon small>fal fa-eye</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>ファイルを確認する</v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="downloadFile(item)">
                      <v-list-item-avatar>
                        <v-icon small>fal fa-download</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>ダウンロード</v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="openMover(item)">
                      <v-list-item-avatar>
                        <v-icon small>fal fa-truck</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>移動する</v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="openRemover(item)">
                      <v-list-item-avatar>
                        <v-icon small>fal fa-trash-alt</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>削除する</v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-action>
          </v-list-item>
          <v-divider :key="`${item.id}_div`"></v-divider>
        </template>
        <v-list-item dense>
          <v-list-item-action>
            <v-btn icon disabled><v-icon small></v-icon></v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-window-item>
    </v-window>
    <v-footer fixed color="primary" class="pl-0 pr-1">
      <v-row dense>
        <v-col cols="6">
          <v-btn text v-if="store.window === 'files'" @click="closeFolder">
            <v-icon small class="mr-2">fal fa-angle-left</v-icon>
            <span>戻る</span>
          </v-btn>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn depressed color="secondary" @click="openUploader">
            <v-icon small class="mr-2">fal fa-plus</v-icon>
            <span>追加する</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>
    <PreviewModal ref="previewer" />
    <MoveModal ref="mover" @done="openFolder(store.folder)" />
    <RemoveModal ref="remover" />
  </v-navigation-drawer>
</template>

<script>
import PreviewModal from './modals/preview'
import RemoveModal from './modals/remove'
import MoveModal from './modals/move'
const DEF = {
  TAB: 0,
  WINDOW: 'folders',
  BANK: 'mitsuisumitomo',
  CARD: 'dc'
}
export default {
  name: 'authorBbookNavigator',
  props: [ 'books' ],
  components: {
    PreviewModal,
    MoveModal,
    RemoveModal
  },
  mounted () {
    this.submit({ type: 'folders' })
  },
  data () {
    return {
      config: {
        status: {
          loading: false,
          active: true,
          expanded: false
        }
      },
      meta: {
        tabs: [
          { slug: 'bank', label: '通帳' },
          { slug: 'card', label: 'カード' }
        ]
      },
      store: {
        tab: DEF.TAB,
        window: DEF.WINDOW,
        bank: DEF.BANK,
        card: DEF.CARD,
        folders: [],
        folder: '',
        files: []
      },
      form: {
        areas: [],
        gid: ''
      }
    }
  },
  methods: {
    change: function (req) {
      const { type } = req
      const bookType = this.meta.tabs[this.store.tab].slug
      if (type === 'book') {
        this.$emit('emit', {
          dest: 'toolbars',
          action: 'changeBookType',
          data: { type: bookType }
        })
        this.$set(this.store, 'window', 'folders')
        this.$set(this.form, 'gid', '')
        this.submit({ type: 'folders' })
      } else if (type === 'company') {
        this.$set(this.store, 'window', 'folders')
        this.submit({ type: 'folders' })
      }
    },
    collect: function (req) {
      const { id } = req || {}
      this.$set(this.form, 'gid', this.form.gid === id ? '' : id)
      this.$nextTick(() => {
        this.$emit('emit', {
          dest: 'toolbars',
          action: 'collectByFile',
          data: { id: this.form.gid }
        })
      })
    },
    openFolder: function (req) {
      const { id } = req
      if (id) {
        this.submit({ type: 'files', bid: id })
        this.$set(this.store, 'folder', req)
      }
    },
    closeFolder: function (req) {
      this.$set(this.store, 'window', 'folders')
    },
    openPreviewer: function (req) {
      const { id } = req || {}
      const { tab } = this.store
      const tabSlug = this.meta.tabs[tab].slug
      if (id && this.$refs.previewer) {
        this.$refs.previewer.open({
          type: tabSlug,
          company: this.store[tabSlug],
          item: req
        })
      }
    },
    openMover: function (req) {
      const { id } = req || { id: '' }
      if (id && this.$refs.mover) {
        this.$refs.mover.open({
          file: req,
          item: this.store.folder,
          items: this.store.folders
        })
      }
    },
    openUploader: function () {
      const tabSlug = this.meta.tabs[this.store.tab].slug
      const companyName = this.store[tabSlug]
      const { id } = this.store.folder || {}
      this.$emit('emit', {
        action: 'upload',
        data: {
          type: tabSlug,
          company: companyName,
          folder: id || ''
        }
      })
    },
    openRemover: function (req) {
      const tabSlug = this.meta.tabs[this.store.tab].slug
      const companyName = this.store[tabSlug]
      this.$refs.remover.open({
        type: tabSlug,
        company: companyName,
        item: req
      })
    },
    downloadFile: function (req) {
      const { id } = req
      if (id) {
        this.submit({ type: 'download', mid: id })
      }
    },
    preSubmit: function (req) {
      const { type, bid, mid } = req || {}
      const { tab } = this.store
      const tabSlug = this.meta.tabs[tab].slug
      const books = this.$props.books && this.$props.books[tabSlug]
      const companyName = this.store[tabSlug]
      const urls = {
        folders: `${this.$url.api}box/get/client/folder/${books[companyName].bid}`,
        files: `${this.$url.api}box/get/client/folder/${bid}`,
        download: `${this.$url.api}box/download/${mid}`
      }
      const fds = {
        folders: {},
        files: {},
        download: {}
      }
      if (type && urls[type] && fds[type]) {
        this.$set(this.config.status, 'loading', true)
        return { type, url: urls[type], fd: fds[type] }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { url, fd, type } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit(res.data.data, type)
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req, submitType) {
      const type = submitType || ''
      if (type === 'folders') {
        this.$set(this.store, 'folders', req)
        this.$set(this.config.status, 'loading', false)
      } else if (type === 'files') {
        this.$set(this.store, 'files', req)
        this.$set(this.store, 'window', 'files')
        this.$set(this.config.status, 'loading', false)
      } else if (type === 'download') {
        window.location.href = req
        this.$set(this.config.status, 'loading', false)
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    },
    toggle: function () {
      this.$set(this.config.status, 'active', !this.config.status.active)
    },
    toggleExpansion: function () {
      this.$set(this.config.status, 'expanded', !this.config.status.expanded)
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isExpanded () {
      return this.config.status.expanded
    },
    getTabItems () {
      return this.meta.tabs.map(it => {
        return it.label
      })
    },
    getTabSlug () {
      return this.meta.tabs[this.store.tab].slug
    },
    getAreaItems () {
      return Object.keys(this.$mango.areaSlugs).map(key => {
        return {
          value: key,
          text: this.$mango.areaSlugs[key]
        }
      })
    },
    getBankItems () {
      return this.$props.books ? Object.keys(this.$props.books.bank).map(key => {
        return {
          text: this.$props.books.bank[key].label,
          value: key
        }
      }) : []
    },
    getCardItems () {
      return this.$props.books ? Object.keys(this.$props.books.card).map(key => {
        return {
          text: this.$props.books.card[key].label,
          value: key
        }
      }) : []
    },
    getBookFolders () {
      return this.store.folders.length ? this.store.folders.map(it => { return it }).sort((a, b) => {
        return a.name > b.name ? -1 : 1
      }) : []
    },
    getBookFiles () {
      return this.store.files.length ? this.store.files.filter(it => {
        const { tags } = it
        return !this.form.areas.length || this.form.areas.filter(area => { return tags && tags.includes(area) }).length
      }) : []
    }
  }
}
</script>